export function getMajorUnitDepositAmount(amount: number): number {
    return amount
}

export function getMinorUnitDepositAmount(amount: number): number {
    return amount * 100
}

export function getDepositAmountFromMinorUnit(amount: number): number {
    return amount / 100
}
